import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QBuiltInspectorConstants } from '../../models/constants/qbuilt-inspector.constants';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'task-groups',
  imports: [
    ReactiveFormsModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
  ],
  templateUrl: './task-groups.component.html',
  styleUrl: './task-groups.component.scss',
})
export class TaskGroupsComponent {
  @Input() type: string;
  @Input() element: any;
  @Input() completeCheck: boolean;
  @Output() emitNAComment = new EventEmitter<string>();
  @Output() emitDNIStatus = new EventEmitter<boolean>();
  @Output() emitTaskDefectsCompleted = new EventEmitter<boolean>();

  facilityNumber: string = sessionStorage.getItem('facilityNumber') || '';

  naTaskGroup: any[] = [];
  commentTask: any[] = [];
  doNotInspectTask: any[] = [];
  designateTaskGroup: any[] = [];
  @Output() emitDNIChange = new EventEmitter<boolean>();

  //NA text
  naCommentLabel: string = this.qbuiltInspConstants.naCommentLabel;
  naDNItext: string = this.qbuiltInspConstants.naDNItext;
  naDNI: string = this.qbuiltInspConstants.didNotInspect;
  taskTypeDidNotInspect: string = this.qbuiltInspConstants.didNotInspect;
  taskTypeComment: string = this.qbuiltInspConstants.comment;
  taskTypeDesignate: string = this.qbuiltInspConstants.designateToggle;

  didNotInspect: FormControl = new FormControl(false);
  naComment: FormControl = new FormControl('');
  customTaskGroups: any[] = [];
  dniControl: FormControl = new FormControl(false);

  sectionList: any[] = [];

  //designate to another station
  enableDesignation: boolean = false;
  currentStation: string = '';

  NATaskValues: any[] = [];

  loading: boolean = false;

  //session storage keys
  cqmsDefectItemsKey: string = this.qbuiltInspConstants.defectItemsKey;
  cqmsSessionKey: string = this.qbuiltInspConstants.cqmsItemsKey;

  constructor(private qbuiltInspConstants: QBuiltInspectorConstants) {}

  ngOnInit() {
    this.loading = true;
    let cqmsDefectItems = sessionStorage.getItem(this.cqmsDefectItemsKey)
      ? JSON.parse(sessionStorage.getItem(this.cqmsDefectItemsKey) || '{}')
      : {};
    sessionStorage.setItem(
      this.cqmsDefectItemsKey,
      JSON.stringify(cqmsDefectItems),
    );

    this.completionCheck(this.completeCheck);
    if (this.NATaskValues && this.NATaskValues.length > 0) {
      this.populateData(this.NATaskValues);
    }

    if (this.element.InjectedTasks && this.element.InjectedTasks.length > 0) {
      const commentTask = this.element.InjectedTasks.find(
        (task: any) => task && task.Name === this.taskTypeComment,
      );
      if (commentTask) {
        this.naComment.setValue(commentTask.ResultValue || '');
      }

      const dniTask = this.element.InjectedTasks.find(
        (task: any) => task && task.Name === this.naDNI,
      );
      if (dniTask) {
        const dniTaskValue = dniTask.ResultValue;
        const dniValue =
          typeof dniTaskValue === 'string'
            ? dniTaskValue.trim() !== ''
            : Boolean(dniTaskValue);
        this.dniControl.setValue(dniValue);
      }
    }
  }

  //disables the comment box if the section is already completed on a multi-section home
  completionCheck(value: boolean) {
    if (value) {
      this.naComment.disable();
      this.dniControl.disable();
    }
  }

  //tracks commentChanges - NA Specific
  addComment(event: any) {
    //reset current station on change
    let cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey)
      ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}')
      : {};
    cqmsSessionItems.currentStationId = this.element.FromStationId;
    sessionStorage.setItem(
      this.cqmsSessionKey,
      JSON.stringify(cqmsSessionItems),
    );
    this.emitNAComment.emit(event.target.value);
  }

  //tracks DNI checkbox changes
  onDNIChange(event: any) {
    //reset current station on change
    let cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey)
      ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}')
      : {};
    cqmsSessionItems.currentStationId = this.element.FromStationId;
    sessionStorage.setItem(
      this.cqmsSessionKey,
      JSON.stringify(cqmsSessionItems),
    );
    const isChecked = event.checked;
    this.emitDNIStatus.emit(isChecked);
  }

  populateData(NaTaskValues: any[]) {
    NaTaskValues.forEach((task) => {
      if (this.element.TaskId === task.TaskId) {
        if (
          task.ResultValue.toLowerCase().replace(/\s/g, '') ==
          this.qbuiltInspConstants.didNotInspect
            .toLowerCase()
            .replace(/\s/g, '')
        ) {
          this.dniControl.setValue(task.ResultValue);
        } else {
          this.naComment.setValue(task.ResultValue);
        }
        this.completionCheck(task.TaskStatusId == 4);
      }
    });
  }
}
